export default "__VITE_ASSET__DRhWrNAf__"